var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "submenus"
  }, [_c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.items
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.items ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Items")])])]), _vm.$whitelabel.isAllowedToAccessPurchaseOrder && _vm.canManagePos ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.purchaseOrder
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.purchaseOrder ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Purchase Orders")])])]) : _vm._e(), _vm.$whitelabel.isAllowedToAccessPurchaseOrder && _vm.canManageSupplierPrices ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.supplierPrices
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.supplierPrices ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Suppliers")])])]) : _vm._e(), _vm.canManage ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.movements
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.movements ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Movements")])])]) : _vm._e(), _vm.canManageWarehouses ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.warehouses
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.warehouses ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Warehouses")])])]) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };